export default __webpack_public_path__ + "static/media/chat.9cca7894.svg";